import { Parser } from "json2csv";
import { saveAs } from "file-saver";
class Controller {
  constructor($injector) {
    "ngInject";
    this.Authorization = $injector.get("Authorization");
  }
  download() {
    const jsonToCsvParser = new Parser();
    this.Authorization.getEndPoints({}).$promise.then((response) => {
      const csv = jsonToCsvParser.parse(response.data);
      const csvFile = new File([csv], "end-points.csv");
      saveAs(csvFile);
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/authorization/authorization.controller.js